import * as ActionType from './actionType';

const initialState = {
  user: {
    merchantId: '60bdca55b84cf500196a6d38',
  },
};

const userReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case ActionType.SAVE_USER_INFO:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default userReducer;
